import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, Subject } from 'rxjs'
import { environment } from 'src/environments/environment'
import CryptoES from 'crypto-es'
import { retry, shareReplay, take } from 'rxjs/operators'
import { JwtHelperService } from '@auth0/angular-jwt'
import { PasswordPolicy } from '../models/password-policy'
import { UserDetails } from '../models/user-details'
declare const ClientJS: any
import * as CryptoJS from 'crypto-js'
import { AuthorizerService } from '@vcomply/authorizer'
import { Router } from '@angular/router'
import { SessionManagementService } from './session-management.service'
import { ROUTE_CONSTANTS } from '../shared/constants/route-constant'
import { INTEGRATION_WORD_CONSTANTS } from '../shared/constants/integration-word-constant'
import { API_URLS } from '../shared/constants/api-urls.constants'

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  constructor(private http: HttpClient, private authorizer: AuthorizerService, private router: Router, private sessionService: SessionManagementService) {}
  private isLoaded: BehaviorSubject<any> = new BehaviorSubject<any>(false)
  loaded: Observable<boolean> = this.isLoaded.asObservable()

  /**It stores the subDomain details as an observable to prevent repeated duplicate Http Calls */
  private subDomainDetailCache: Subject<any> = new Subject<any>()
  subDomainDetails: Observable<boolean> = this.subDomainDetailCache.asObservable().pipe(shareReplay(1))
  /**
   * Global state of utility service
   */
  globalState: any = {
    userIP: '',
    subDomain: '',
    domainDetails: null,
    userGeoInfo: null,
    passwordPolicy: {
      minLength: 8,
      isSmallCase: true,
      isUpperCase: true,
      oneDigit: true,
      specialCharacter: true,
    },
  }
  /**
   * Sets loading state
   * @param type boolean
   */
  setLoadingState(type: boolean) {
    this.isLoaded.next(type)
  }

  encrypt(password: any) {
    return CryptoES.AES.encrypt(password, 'I@MTHEVC0MPLYUSER').toString()
  }

  decrypt(password: any) {
    // return CryptoES.AES.decrypt(password, 'I@MTHEVC0MPLYUSER').toString(CryptoES.enc.Utf8)
    let bytes = CryptoES.AES.decrypt(password, 'I@MTHEVC0MPLYUSER')
    password = bytes.toString(CryptoES.enc.Utf8)
    password = JSON.parse(password)
    return password
  }

  /**
   * Returns the current subdomain
   * @returns sub domain of the current window
   */
  getSubDomain(): string {
    const host = window.location.host
    const subDomain = localStorage.getItem('subDomain') // host.split('.')[0];
    if (subDomain && subDomain?.trim()?.length > 0) {
      this.globalState.subDomain = subDomain.toLowerCase()
      return this.globalState.subDomain
    } else {
      return host.split('.')[0].toLowerCase()
    }
  }
  /**
   * Returns  user details
   * @returns Object
   */
  getUserDetails() {
    const client = new ClientJS()
    const userDetails: UserDetails = {
      fingerprint: client.getFingerprint(),
      client_ip_addr: this.globalState.userIP,
      browser_name: client.getBrowser(),
      browser_version: client.getBrowserVersion(),
      platform_name: client.getOS(),
      platform_version: client.getOSVersion(),
    }
    return userDetails
  }

  /**
   * Sets ip in global state
   */
  setIpInGlobalState() {
    if (!this.globalState.userIP) {
      this.getIpAddress().subscribe((res: any) => {
        this.globalState.userIP = res?.ip
      })
    }
  }

  setPasswordPolicy(policy = this.globalState.domainDetails) {
    if (policy?.password_policy) {
      const passwordPolicy: PasswordPolicy = {
        minLength: policy?.password_policy?.min_password_length ?? 8,
        isSmallCase: policy?.password_policy?.MANDATORY_CHARACTER?.includes('LOWER_CASE') ? true : false,
        isUpperCase: policy?.password_policy?.MANDATORY_CHARACTER?.includes('UPPER_CASE') ? true : false,
        oneDigit: policy?.password_policy?.MANDATORY_CHARACTER?.includes('NUMERIC') ? true : false,
        specialCharacter: policy?.password_policy?.MANDATORY_CHARACTER?.includes('SPECIAL_CHARACTER') ? true : false,
      }
      this.globalState.passwordPolicy = passwordPolicy
    } else {
      this.globalState.passwordPolicy = {
        minLength: 8,
        isSmallCase: true,
        isUpperCase: true,
        oneDigit: true,
        specialCharacter: true,
      }
    }
  }

  /**
   * Gets ip address
   * @returns  Observable
   */
  getIpAddress() {
    return this.http.get<{ ip: string }>(API_URLS.IP_URL).pipe(retry(3), shareReplay(1))
  }
  /**
   * Sets geo location info of the user
   */
  setGeoLocationInfo() {
    this.http
      .get<{ ip: string }>(`https://api.ipstack.com/${this.globalState.userIP}?access_key=fc6527e9ae98bb87ffcca52e0f6155c7&format=1`)
      .pipe(retry(2))
      .subscribe({
        next: (res: any) => {
          this.globalState.userGeoInfo = res
        },
        error: () => {},
      })
  }

  /**
   * set subdomain details when application load in a Subject
   * @param [subDomain] current subdomain on which application is opened
   * @returns  Observable
   */
  setSubDomainDetails(subDomain = this.globalState.subDomain) {
    this.http
      .post<any>(environment.authEndpoint + '?mode=verifyDomain', {
        subdomain: subDomain,
      })
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          this.subDomainDetailCache.next(res)
          this.globalState.subDomainDetails = res
        },
        error: (error) => {
          this.subDomainDetailCache.error(error)
          this.globalState.subDomainDetails = error
        },
      })
  }

  getPasswordPolicyBasedOnSubDomain(subDomain: string) {
    return this.http.post<any>(environment.authEndpoint + '?mode=verifyDomain', {
      subdomain: subDomain,
    })
  }

  //This function is responsible to detecting weather a user is logged in or not
  isLoggedIn() {
    if (this.authorizer.isTokenExpired()) {
      this.logout()
      return false
    } else {
      return true
    }
    // const helper = new JwtHelperService();
    // const userToken = localStorage.getItem("currentUser");
    // if (userToken) {
    //   const myRawToken = JSON.parse(userToken).token;
    //   const isExpired = helper.isTokenExpired(myRawToken);
    //   if (isExpired === true) { this.logout(); }
    //   if (isExpired === false) { return true; }
    //   return false;
    // }
    // return false;
  }
  logout() {
    localStorage.removeItem('currentUser')
  }

  emailCheck(email: string) {
    return this.http.post(environment.emailCheck + 'auth/verify_flow', { email: email })
  }

  checkForAD(email: string) {
    return this.http.post(environment.emailCheck + 'auth/verify_flow', { email: email })
  }

  sendPasswordResetLink(email: string) {
    return this.http.post(environment.orgEndpoint_TL + 'resetpassword', { member_email: email, subdomain: this.getSubDomain() })
  }

  generatePasswordValidator(passwordPolicy: PasswordPolicy) {
    return (`^${passwordPolicy.isUpperCase ? '(?=.*?[A-Z])' : ''}${passwordPolicy.isSmallCase ? '(?=.*?[a-z])' : ''}${passwordPolicy.oneDigit ? '(?=.*?[0-9])' : ''}${passwordPolicy.specialCharacter ? '(?=.*?[<>~`,./"#?!@$%^&*-+()=])' : ''}` + `.{${passwordPolicy.minLength},}$`)
      .toString()
      .trim()
  }

  changePassword(payload: any) {
    return this.http.post<any>(environment.orgEndpoint_TL + 'setnewpassword', payload).pipe(retry(2))
  }

  fetchSSOConfig(subdomain: string) {
    return this.http.post<any>(environment.authEndpoint + '?mode=adCred', { subdomain }).pipe(retry(2))
  }
  loginUserFromCognito(token: any, payload: any) {
    return this.http.post(environment.authEndpoint + '?mode=login&code=' + token + '&subdomain=' + this.getSubDomain(), payload)
  }

  redirectTo(redirectScreen: 'THANK_YOU' | 'DASHBOARD', additionalData?: any) {
    this.setLoadingState(false)
    switch (redirectScreen) {
      case 'THANK_YOU': {
        try {
          window.location.href = 'https://www.v-comply.com/thank-you'
        } catch {
          this.setLoadingState(true)
        }
        break
      }
      case 'DASHBOARD': {
        try {
          if (additionalData) {
            const obj = { token: additionalData.token ?? '' }
            this.removeSearchHistory()
            localStorage.setItem('currentUser', JSON.stringify(obj))
          }
          this.redirectToURL()
        } catch {
          this.setLoadingState(true)
        }
        break
      }
    }
  }
  getAssociatedDomainOrg(domain: string) {
    return this.http.post(environment.orgEndpoint_TL + 'domaindetails&domain_name=' + domain, {}).pipe(retry(1))
  }

  isIntegrationMode() {
    if (localStorage.getItem('integration')) {
      const integration = JSON.parse(localStorage.getItem('integration') ?? '')
      if (integration?.type && Date.now() - integration?.timestamp < 900000) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  wordAuthorise(integration: any) {
     this.checkConsent({ emailAddress: integration?.email }).subscribe({
       next: (res: any) => {
         if (res) {
           if (res.success) {
             window.close() 
           } 
        }
      },
      error: (err: any) => {
         this.router.navigate([`${ROUTE_CONSTANTS.AUTHORIZE_WORD}`]) 
         console.log('err', err)
       },
     })
  }


  checkConsent(payload: any) {
    return this.http.post(environment.authEndpoint + INTEGRATION_WORD_CONSTANTS.CHECK_USER_CONTENT_MODE, payload)
  }

  redirectToIntegration(): void {
    if (localStorage.getItem(INTEGRATION_WORD_CONSTANTS.INTEGRATION)) {
      const integration = JSON.parse(localStorage.getItem(INTEGRATION_WORD_CONSTANTS.INTEGRATION) ?? '{}')
      if (integration?.type === INTEGRATION_WORD_CONSTANTS.INTEGRATION_OUTLOOK) {
        this.router.navigate([`${ROUTE_CONSTANTS.AUTHORIZE_OUTLOOK}`])
      } else if (integration?.type === INTEGRATION_WORD_CONSTANTS.INTEGRATION_WORD) {
        this.wordAuthorise(integration)
      }
    }
  }

  public redirectToURL() {
    const URL = this.sessionService.getItemFromSession('redirectURL')
    if (URL) {
      this.sessionService.removeItemFromSession('redirectURL')
      window.location.href = URL
    } else {
      window.location.href = environment.appUrl + 'global-dashboard'
    }
  }

  public removeSearchHistory() {
    localStorage.removeItem('recent-searches')
  }
}
